import Vue from "vue";
import "../../common/vue/common";
import AppConfig from "~/appConfig";
import App from './app-vue.vue';
import User from "../../common/models/user";
import BookmarkMenu from "./models/bookmarkMenu";
import store from "../../common/state/store";
import StoreFactory from "./store/storeFactory";
import Selected from "./store/modules/selected";
import Organization from "../../common/models/organization";
import {initSidebarCollapse} from "~/collapsableSidebar"

const onReady = function () {
  const hideSidebar: boolean = $(document).find('.no-sidebar').length > 0;
  if (hideSidebar) return;

  const $rootElement = $(document).find('#vue-primary-sidebar');
  if ($rootElement.length === 0) return;

  const orgJson = $rootElement.data('organization');
  if (orgJson === undefined) {
    $rootElement.parent().addClass('no-sidebar').removeClass('collapsed-sidebar expanded-sidebar');
    return;
  }

  window.AppConfig = new AppConfig();
  Selected.register(Selected);

  const user = new User().loadFromJson($rootElement.data('user'));
  Selected.currentUser.set(user);

  const organization: Organization = Organization.repo.findOrCreate(orgJson.id).loadFromJson(orgJson);
  const organization_folders = $rootElement.data('folders-for-bookmark-link-builder');
  organization.loadFromJson({folders: organization_folders});
  Selected.organization.set(organization);

  const bookmarkMenu = new BookmarkMenu().loadFromJson($rootElement.data('bookmark-menu'));
  const portalsForBookmarkLinkBuilder = $rootElement.data('portals-for-bookmark-link-builder');

  StoreFactory.registerModules();

  const app = new Vue({
    el: "#vue-primary-sidebar",
    store: store,
    created(): void {
      store.commit('bookmarkMenuStore/setBookmarkMenu', bookmarkMenu);
      store.commit('bookmarkLinkBuilderInterfaceStore/setUser', user);
      store.commit('bookmarkLinkBuilderInterfaceStore/setOrganization', organization);
      store.commit('bookmarkLinkBuilderInterfaceStore/setPortalsForDropdownSelect', portalsForBookmarkLinkBuilder);
      store.commit('folderLookupStore/setOrganization', organization);
    },
    mounted() {
      initSidebarCollapse()
    },
    render: h => h(App),
  });
};

$(onReady);
